import { render, staticRenderFns } from "./SectionFiles.vue?vue&type=template&id=4561cbc7&"
import script from "./SectionFiles.vue?vue&type=script&lang=js&"
export * from "./SectionFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports